import React from 'react';
import Status from '../../common/React/Status';
import Button from '../../common/button/Button';

const error404 = () => (
    <Status code={404}>
        <div className="pageWrapper tw-container tw-m-auto tw-px-5 tw-pb-8">
            <section>
                <h2>Ops! Página não encontrada.</h2>
                <div className="btnHome">
                    <Button to="/" title="Ir para home">
                        Voltar para o início
                    </Button>
                </div>
            </section>
        </div>
    </Status>
);

export default error404;
